import PropTypes from 'prop-types'
import { DetailsContainer as Container } from '@calendly/booking-kit'

export const Wrapper = ({ flow = 'column', ...props }) => (
  <Container data-container="details" flow={flow} {...props} />
)

Wrapper.propTypes = {
  flow: PropTypes.oneOf(['column', 'row'])
}
